import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { AuthCallbackComponent } from './auth/auth-callback.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login.component').then(m => m.LoginComponent),
  },
  { path: 'auth/callback', component: AuthCallbackComponent },
  {
    path: 'responses',
    loadComponent: () => import('./pages/responses.component').then(m => m.ResponsesComponent),
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [authGuard],
  },
  {
    path: 'systems',
    loadComponent: () => import('./pages/systems.component').then(m => m.SystemsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'users',
    loadComponent: () => import('./pages/users.component').then(m => m.UsersComponent),
    canActivate: [authGuard],
  },
];
